// =============================================================================
// FILE PATH : src/modules/pms/task_template/components/TaskTemplateSummaryCards.js
// MODULE    : PMS → Task Template
// PURPOSE   : Summary cards (Total / Project / Equipment / Inactive)
// =============================================================================

import React from "react";

const cardStyle = {
  flex: 1,
  padding: "16px",
  borderRadius: "10px",
  background: "#fff",
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  cursor: "pointer",
  transition: "all 0.2s ease"
};

const activeStyle = {
  border: "2px solid #1976d2",
  background: "#f0f7ff"
};

const titleStyle = {
  fontSize: "14px",
  color: "#666",
  marginBottom: "6px"
};

const valueStyle = {
  fontSize: "22px",
  fontWeight: "600",
  color: "#222"
};


const TaskTemplateSummaryCards = ({
  templates = [],
  activeFilter,
  onFilterChange
}) => {

  // ---------------------------------------------------------------------------
  // CALCULATIONS
  // ---------------------------------------------------------------------------
  const total = templates.length;

  const projectCount = templates.filter(
    (t) => t.template_type === "PROJECT"
  ).length;

  const equipmentCount = templates.filter(
    (t) => t.template_type === "EQUIPMENT"
  ).length;

  const inactiveCount = templates.filter(
    (t) => !t.is_active
  ).length;

  // ---------------------------------------------------------------------------
  // CARD CLICK HANDLER
  // ---------------------------------------------------------------------------
  const handleClick = (type) => {
    onFilterChange(type);
  };

  return (
    <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>

      {/* TOTAL */}
      <div
        style={{
          ...cardStyle,
          ...(activeFilter === "ALL" ? activeStyle : {})
        }}
        onClick={() => handleClick("ALL")}
      >
        <div style={titleStyle}>Total Templates</div>
        <div style={valueStyle}>{total}</div>
      </div>

      {/* PROJECT */}
      <div
        style={{
          ...cardStyle,
          ...(activeFilter === "PROJECT" ? activeStyle : {})
        }}
        onClick={() => handleClick("PROJECT")}
      >
        <div style={titleStyle}>Project Templates</div>
        <div style={valueStyle}>{projectCount}</div>
      </div>

      {/* EQUIPMENT */}
      <div
        style={{
          ...cardStyle,
          ...(activeFilter === "EQUIPMENT" ? activeStyle : {})
        }}
        onClick={() => handleClick("EQUIPMENT")}
      >
        <div style={titleStyle}>Equipment Templates</div>
        <div style={valueStyle}>{equipmentCount}</div>
      </div>

      {/* INACTIVE */}
      <div
        style={{
          ...cardStyle,
          ...(activeFilter === "INACTIVE" ? activeStyle : {})
        }}
        onClick={() => handleClick("INACTIVE")}
      >
        <div style={titleStyle}>Inactive</div>
        <div style={valueStyle}>{inactiveCount}</div>
      </div>

    </div>
  );
};

export default TaskTemplateSummaryCards;